import React from 'react';
import PropTypes from 'prop-types';

import { Scope } from 'informed';
import { Cell, Grid } from 'react-md';

import DatePickerGenericField from '../../Common/DatePickerGenericField';
import Select from '../../Common/Select';
import TextField from '../../Common/TextField';

const PartyFieldsComponent = ({ config, strings, readOnly }) => (
  <Grid className="grid party">
    <Scope scope="party">
      <div
        key="gender"
        className={Cell.getClassName({ size: 1 })}
        style={{
          minWidth: '65px',
          maxWidth: '80px',
        }}
      >
        <Select
          className="field select"
          key="gender"
          field="gender"
          id="select-gender"
          name="gender"
          shrink
          label={strings['block.covered.party.field.gender.label']}
          options={config.covered.genders.options}
          disabled={readOnly}
          required
        />
      </div>
      <div key="name" className={Cell.getClassName({ size: 4 })}>
        <TextField
          className="field text"
          key="name"
          field="name"
          id="numberfield-name"
          name="name"
          shrink
          label={strings['block.covered.party.field.name.label']}
          placeholder=""
          disabled={readOnly}
          required
        />
      </div>
      <div key="first_name" className={Cell.getClassName({ size: 4 })}>
        <TextField
          className="field text"
          key="first_name"
          field="first_name"
          id="numberfield-first_name"
          name="first_name"
          shrink
          label={strings['block.covered.party.field.first_name.label']}
          placeholder=""
          disabled={readOnly}
          required
        />
      </div>
      <div key="birth_date" className={Cell.getClassName({ size: 3 })}>
        <DatePickerGenericField
          type="date"
          className="field text"
          key="birth_date"
          field="birth_date"
          id="numberfield-birth_date"
          name="birth_date"
          shrink
          label={strings['block.covered.party.field.birth_date.label']}
          errorLabel={strings['error.date']}
          placeholder="JJ/MM/AAAA"
          disabled={readOnly}
          required
        />
      </div>
      {/* SSN */}
      {/* <div key="ssn" className={Cell.getClassName({ size: 6 })}>
        <TextField
          className="field text"
          key="ssn"
          field="ssn"
          id="field-ssn"
          name="ssn"
          shrink
          label={get(strings, 'block.transform.party.field.ssn.label', 'SSN')}
          placeholder=""
          disabled={readOnly}
          strings={strings}
        />
      </div> */}
    </Scope>
  </Grid>
);

PartyFieldsComponent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  strings: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  config: PropTypes.any.isRequired,
  readOnly: PropTypes.bool.isRequired,
};

PartyFieldsComponent.defaultProps = {};

export default PartyFieldsComponent;
